PJQ.models.timecards = {};

PJQ.models.timecards.TimeCard = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'timeCardId',
    endpoint: function () {
        let params = [];
        if (this.options.context)
            params.push({
                parameter: 'context',
                value: this.options.context
            });
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards',
                value: this.get('timeCardId')
            }
        ], params);
    },
    parse: function(model) {
        if (!model)
            return;

        if (model.date)
            model.date = PJQ.helpers.dateHelpers.parseDateString(model.date, false);

        if (model.groups)
            model.groups = new PJQ.collections.timecards.TimeCardGroups(model.groups.models ? model.groups.models : model.groups);

        this.lineItems = new PJQ.collections.timecards.TimeCardLineItems(model.lineItems);
        this.installedQuantities = new PJQ.collections.productionQuantities.InstalledQuantities(model.installedQuantities);

        return model;
    },
    getTotalTime: function() {
        return this.get('regularHours')+this.get('doubletimeHours')+this.get('overtimeHours');
    },
    beforeSave: function () {
        this.set({
            lineItems: this.lineItems.toJSON()
        });
    },
});

PJQ.models.timecards.TimeCardCategory = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards',
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'categories',
                value: this.get('timeCardCategoryId')
            }
        ]);
    },
    idAttribute: 'timeCardCategoryId'
});

PJQ.models.timecards.TimeCardGroup = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'timeCardGroupId'
});

PJQ.models.timecards.TimeCardLineItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

// Settings
PJQ.models.timecards.TimeCardUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [];
        if (this.options.forCompany) {
            params.push({
                parameter: 'forCompany',
                value: true
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ], params);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.timecards.TimeCardSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [
            {
                parameter: 'contactId',
                value: this.options.contact ? this.options.contact.get('contactId') : 0
            },
            {
                parameter: 'projectId',
                value: this.options.project ? this.options.project.get('projectId') : 0
            }
        ];

        if(this.options.project){
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'timecards'
                },
                {
                    endpoint: 'settings'
                }
            ], params);
        }
        else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'timecards'
                },
                {
                    endpoint: 'settings'
                }
            ], params);
        }
    }
});

PJQ.collections.timecards = {};

PJQ.collections.timecards.TimeCardCategories = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.timecards.TimeCardCategory,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'categories'
            }
        ], params);
    }
});

PJQ.collections.timecards.TimeCards = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.timecards.TimeCard,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards'
            }
        ], params);
    },
    parse: function (data) {
        if (this.options.isExport) {
            this.exportURL = data.url;
        }
        else {
            this.totalRows = 0;
            if (data) {
                this.totalRows = data.totalRows;
                return data.rows;
            }
        }
        return null;
    },
    getTimeCard: function(id, date) {
        let result = null;

        _.each(this.models, function(model) {
            if (model.get('id') === id && PJQ.helpers.dateHelpers.getDateString(model.get('date'), PJQ.helpers.dateHelpers.dateFormats.DATE_YMD) === PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD) && !model.get('deletedOn'))
                result = model;
        });

        return result;
    }
});

PJQ.collections.timecards.TimeCardGroups = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.timecards.TimeCardGroup
});

PJQ.collections.timecards.TimeCardLineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.timecards.TimeCardLineItem
});

PJQ.collections.timecards.TimeCardContextProjects = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [
            {
                parameter: 'startDate',
                value: this.options.startDate
            },
            {
                parameter: 'endDate',
                value: this.options.endDate
            }
        ];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards'
            },
            {
                endpoint: 'context',
                value: this.options.id
            },
            {
                endpoint: 'projects'
            }
        ], params);
    }
});

PJQ.collections.timecards.TimeCardProjects = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards'
            },
            {
                endpoint: 'projects'
            }
        ], params);
    },
    parse: function (data) {
        if (this.options.isExport) {
            this.exportURL = data.url;
        }
        else {
            this.totalRows = 0;
            if (data) {
                this.totalRows = data.totalRows;
                return data.rows;
            }
        }
        return null;
    }
});

PJQ.collections.timecards.TimeCardContacts = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'timecards'
            },
            {
                endpoint: 'contacts'
            }
        ], params);
    },
    parse: function (data) {
        if (this.options.isExport) {
            this.exportURL = data.url;
        }
        else {
            this.totalRows = 0;
            if (data) {
                this.totalRows = data.totalRows;
                return data.rows;
            }
        }
        return null;
    }
});